module.exports = __webpack_public_path__ + "media/images/announcement-red-eea4c97481a3620b214d24523f23bc25.svg";